import classNames from 'classnames';
import { RowProps } from './Row.types';
import * as S from './Row.styles';

/**
 * @deprecated
 * The prefered way is to use flex positionning and a container in a component
 */
const Row = (props: RowProps) => {
  const {
    children,
    align,
    padding,
    style,
    bottom = 40,
    className,
    wrap,
    noWrap,
    tp = 12,
    xs = 12,
    md = 12,
    lg = 12,
    noInlineStyle = false,
    onClick,
    ...rest
  } = props;
  return (
    <S.Row
      className={classNames({
        Row: true,
        [`Row--${align}`]: align,
        'Row--wrap': wrap,
        'Row--noWrap': noWrap,
        [className]: className,
      })}
      style={
        !noInlineStyle
          ? {
              ...style,
              padding,
              marginBottom: bottom,
            }
          : undefined
      }
      {...{
        tp,
        xs,
        md,
        lg,
      }}
      onClick={onClick}
      {...rest}
    >
      {children}
    </S.Row>
  );
};

export default Row;
